import type * as Highcharts from 'highcharts';
import type { NamedSolution } from '../../types';
import { compare_name_asc } from '../utils';

const pad2 = (value: number) => ('0' + value).slice(-2);

/** Monthly production losses of each solution; the year is shown only when several solutions are compared. */
export const buildProductionLossesOptions = (data: NamedSolution[]): Highcharts.Options => {
  const timestamps = (data[0]?.data?.monthly?.times || []).map((dateStr) => new Date(dateStr).getTime());
  const isComparison = data.length > 1;
  const formatMonth = (d: Date) => (isComparison ? d.getFullYear() + '-' + pad2(d.getMonth() + 1) : pad2(d.getMonth() + 1));
  const series = [...data].sort(compare_name_asc).map(
    (item): Highcharts.SeriesColumnOptions => ({
      type: 'column',
      name: item.name,
      data: (item?.data?.monthly.values.production_losses || []).map((value, index) => [timestamps[index], value]),
    }),
  );

  return {
    chart: {
      type: 'column',
      zooming: { type: 'x' },
      panning: { enabled: true, type: 'x' },
      panKey: 'shift',
    },
    title: { text: 'Production Losses', align: 'left' },
    xAxis: {
      type: 'datetime',
      title: { text: 'Date' },
      labels: {
        rotation: 0,
        style: { fontSize: '12px' },
        formatter: function () {
          return formatMonth(new Date(this.value));
        },
      },
      gridLineWidth: 1,
    },
    yAxis: { title: { text: 'Production Losses (MWh/month)' } },
    tooltip: {
      formatter: function () {
        return (
          formatMonth(new Date(this.x as number)) +
          '<br><b>' +
          this.series.name +
          '</b>: ' +
          Math.round((this.point.y as number) * 100) / 100 +
          ' MWh'
        );
      },
    },
    credits: { enabled: false },
    plotOptions: { column: { pointPadding: 0.2, borderWidth: 0 } },
    series,
  };
};
